// extracted by mini-css-extract-plugin
export var copied = "CopyButton-module--copied--9LNMP";
export var root = "CopyButton-module--root--f2OUC";